export const fullScreenTablePickerScreenSGroups = [
    "table_read",
    "lounge_map_item_read",
];